import React, { useState, useEffect } from "react";
import { Modal, Table, Button, Space, message, Switch, Tooltip, Select, Segmented, Input, Tag } from "antd";
import { SettingOutlined, SettingFilled } from "@ant-design/icons";
import { PickLineSettingModal } from "./PickLineSettingModal";
import { PickTGGroupModal } from "./PickTGGroupModal";
import { PickupSubIdentifiersModal } from "./PickupSubIdentifiersModal";
import { GroupSettingModal } from "./GroupSettingModal";
import { NotifyGroupAPI, ConfigTargetGroupsOptAPI, ConfigFilterOptAPI, ConfigWarningOptAPI, TelegramConfigAPI, LineConfigAPI } from "../../constants/GenericAPI";

// 自定義設定圖標組件，適應深色主題
const SettingIcon = ({ style }) => (
  <svg
    viewBox="64 64 896 896"
    focusable="false"
    data-icon="setting"
    width="1em"
    height="1em"
    fill="var(--primary-text)"
    aria-hidden="true"
    style={style}
  >
    <path d="M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z"></path>
  </svg>
);

export default function MessageGroupModal({ open, onCancel }) {
  const [loading, setLoading] = useState(false);
  const [lineModalVisible, setLineModalVisible] = useState(false);
  const [tgModalVisible, setTgModalVisible] = useState(false);
  const [subIdentifiersModalVisible, setSubIdentifiersModalVisible] = useState(false);
  const [groupData, setGroupData] = useState([]);
  const [filteredGroupData, setFilteredGroupData] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);
  const [targetGroupOptions, setTargetGroupOptions] = useState([]);
  const [warningPhraseOptions, setWarningPhraseOptions] = useState([]);
  const [lineSettings, setLineSettings] = useState([]);
  const [selectedLineSetting, setSelectedLineSetting] = useState(null);
  const [tgSettings, setTGSettings] = useState([]);
  const [selectedTGSetting, setSelectedTGSetting] = useState(null);
  const [selectedSubIdentifiers, setSelectedSubIdentifiers] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [groupModalVisible, setGroupModalVisible] = useState(false);
  const [searchText, setSearchText] = useState("");

  const renderSettingIcon = (hasSetting, onClick) => {
    const iconClass = hasSetting ? "setting-icon setting-filled" : "setting-icon setting-outlined";
    return (
      <span
        className={iconClass}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.stopPropagation();
          if (onClick) onClick();
        }}
      >
        {hasSetting ? <SettingFilled /> : <SettingOutlined />}
      </span>
    );
  };

  // 處理子識別碼設定
  const handleSubIdentifiersSettings = (group, subIds) => {
    setSelectedGroup(group);
    setSelectedSubIdentifiers(subIds);
    setSubIdentifiersModalVisible(true);
  };

  const handleSubIdentifiersPickup = async (formData) => {
    try {
      if (formData === null) {
        // 用戶選擇移除設定
        // 更新本地 groupData 狀態，移除 sub_identifiers
        setGroupData((prevGroups) => {
          return prevGroups.map((group) => {
            if (group.id === selectedGroup.id) {
              return {
                ...group,
                sub_identifiers: [], // 清空 sub_identifiers
              };
            }
            return group;
          });
        });

        // 清空選中的設定
        setSelectedSubIdentifiers(null);
      } else {
        // 更新本地 groupData 狀態
        setGroupData((prevGroups) => {
          return prevGroups.map((group) => {
            if (group.id === selectedGroup.id) {
              return {
                ...group,
                sub_identifiers: formData,
              };
            }
            return group;
          });
        });

        message.success("子識別碼設定已選擇成功");
      }
    } catch (error) {
      console.error("處理子識別碼設定選擇失敗:", error);
      message.error("處理子識別碼設定選擇失敗");
    }
    setSubIdentifiersModalVisible(false);
  };

  // 處理 LINE 設定
  const handleLineSettings = (group, line) => {
    setSelectedGroup(group);
    setSelectedLineSetting(line);
    setLineModalVisible(true);
  };

  const handleLinePickup = async (formData) => {
    try {
      if (formData === null) {
        // 用戶選擇移除設定
        // 更新本地 groupData 狀態，移除 line_ids
        setGroupData((prevGroups) => {
          return prevGroups.map((group) => {
            if (group.id === selectedGroup.id) {
              return {
                ...group,
                line_ids: [], // 清空 line_ids
              };
            }
            return group;
          });
        });

        // 清空選中的設定
        setSelectedLineSetting(null);
      } else {
        // 用戶選擇了新的設定
        // 更新本地 lineSettings 狀態
        setLineSettings((prev) => {
          const existingSetting = prev.find((item) => item.id === formData.id);
          if (existingSetting) {
            // 如果已存在，更新它
            return prev.map((item) => (item.id === formData.id ? { ...item, ...formData } : item));
          } else {
            // 如果不存在，添加到列表
            return [...prev, formData];
          }
        });

        // 更新選中的設定
        setSelectedLineSetting(formData);

        // 更新本地 groupData 狀態，確保 line_ids 被正確更新
        setGroupData((prevGroups) => {
          return prevGroups.map((group) => {
            if (group.id === selectedGroup.id) {
              // 處理 line_ids - 只保留一個設定 ID
              const lineIds = [formData.id];

              // 返回更新後的群組
              return {
                ...group,
                line_ids: lineIds, // 保持為數組格式，只包含一個 ID
              };
            }
            return group;
          });
        });

        message.success("LINE 設定已選擇成功");
      }
    } catch (error) {
      console.error("處理 LINE 設定選擇失敗:", error);
      message.error("處理 LINE 設定選擇失敗");
    }
    setLineModalVisible(false);
  };

  // 處理 Telegram 設定
  const handleTGSettings = (group, tg) => {
    setSelectedGroup(group);
    setSelectedTGSetting(tg);
    setTgModalVisible(true);
  };

  const handleTGPickup = async (formData) => {
    try {
      if (formData === null) {
        // 用戶選擇移除設定
        // 更新本地 groupData 狀態，移除 tg_ids
        setGroupData((prevGroups) => {
          return prevGroups.map((group) => {
            if (group.id === selectedGroup.id) {
              return {
                ...group,
                tg_ids: JSON.stringify([]), // 清空 tg_ids 並轉為 JSON 字串
              };
            }
            return group;
          });
        });

        // 清空選中的設定
        setSelectedTGSetting(null);
      } else {
        // 用戶選擇了新的設定
        // 更新本地 tgSettings 狀態
        setTGSettings((prev) => {
          const existingSetting = prev.find((item) => item.id === formData.id);
          if (existingSetting) {
            // 如果已存在，更新它
            return prev.map((item) => (item.id === formData.id ? { ...item, ...formData } : item));
          } else {
            // 如果不存在，添加到列表
            return [...prev, formData];
          }
        });

        // 更新選中的設定
        setSelectedTGSetting(formData);

        // 更新本地 groupData 狀態，確保 tg_ids 被正確更新
        setGroupData((prevGroups) => {
          return prevGroups.map((group) => {
            if (group.id === selectedGroup.id) {
              // 處理 tg_ids - 只保留一個設定 ID
              const tgIds = [formData.id];

              // 返回更新後的群組
              return {
                ...group,
                tg_ids: JSON.stringify(tgIds), // 轉為 JSON 字串
              };
            }
            return group;
          });
        });

        message.success("Telegram 設定已選擇成功");
      }
    } catch (error) {
      console.error("處理 Telegram 設定選擇失敗:", error);
      message.error("處理 Telegram 設定選擇失敗");
    }
    setTgModalVisible(false);
  };

  // 新增目的群變更的函數
  const handleTargetGroupChange = async (newValue, record) => {
    try {
      // 呼叫 API 更新目的群
      await NotifyGroupAPI.updateTargetGroupOpt(record.id, newValue);

      // 更新本地資料
      setGroupData((prevData) => prevData.map((item) => (item.id === record.id ? { ...item, tg_option_id: newValue } : item)));

      message.success("已更新目的群");
    } catch (error) {
      message.error("更新目的群設定失敗");
      console.error("更新目的群設定失敗:", error);
    }
  };

  // 新增警示語範本變更的函數（不選 = 傳 0，後端寫 NULL）
  const handleWarningPhraseChange = async (newValue, record) => {
    try {
      await NotifyGroupAPI.updateWarningPhrase(record.id, newValue ?? 0);
      setGroupData((prevData) => prevData.map((item) => (item.id === record.id ? { ...item, warning_phrase_id: newValue ?? null } : item)));
      message.success("已更新警示語");
    } catch (error) {
      message.error("更新警示語設定失敗");
      console.error("更新警示語設定失敗:", error);
    }
  };

  // 新增處理篩選器變更的函數
  const handleFilterChange = async (newValue, record) => {
    try {
      // 呼叫 API 更新篩選器
      await NotifyGroupAPI.updateFilterOpt(record.id, newValue);

      // 更新本地資料
      setGroupData((prevData) => prevData.map((item) => (item.id === record.id ? { ...item, filter_id: newValue } : item)));

      message.success("已更新篩選器設定");
    } catch (error) {
      message.error("更新篩選器設定失敗");
      console.error("更新篩選器設定失敗:", error);
    }
  };

  // 新增處理狀態變更的函數
  const handleStatusChange = async (checked, record) => {
    try {
      // 呼叫 API 更新狀態
      await NotifyGroupAPI.updateStatus(record.id, checked ? 1 : 0);
      // 更新本地資料
      setGroupData((prevData) => prevData.map((item) => (item.id === record.id ? { ...item, is_active: checked ? 1 : 0 } : item)));
      message.success(`已${checked ? "啟用" : "停用"}該群組`);
    } catch (error) {
      message.error("更新狀態失敗");
      console.error("更新狀態失敗:", error);
    }
  };

  // 獲取所有群組資料
  const fetchAllGroupData = async () => {
    setLoading(true);
    try {
      const [filterOptionsRes, targetGroupOptionsRes, notificationGroupsRes, lineSettingsRes, telegramSettingsRes, warningPhraseRes] = await Promise.all([
        ConfigFilterOptAPI.getAll(),
        ConfigTargetGroupsOptAPI.getAll(),
        NotifyGroupAPI.getAll(),
        LineConfigAPI.getAll(),
        TelegramConfigAPI.getAll(),
        ConfigWarningOptAPI.getAll(),
      ]);

      setFilterOptions(filterOptionsRes.data.data);
      setGroupData(notificationGroupsRes.data.data);
      setFilteredGroupData(notificationGroupsRes.data.data);
      setLineSettings(lineSettingsRes.data.data);
      setTGSettings(telegramSettingsRes.data.data);
      setTargetGroupOptions(targetGroupOptionsRes.data.data);
      setWarningPhraseOptions(warningPhraseRes.data.data);
    } catch (error) {
      console.error("獲取群組資料失敗:", error);
      message.error("獲取群組資料失敗");
    } finally {
      setLoading(false);
    }
  };

  // 當 Modal 開啟時獲取資料
  useEffect(() => {
    if (open) {
      fetchAllGroupData();
    }
  }, [open]);

  // 處理關閉 Modal，清空搜尋並重設過濾資料
  const handleClose = () => {
    setSearchText("");
    setFilteredGroupData(groupData);
    onCancel();
  };

  // 當 groupData 或搜尋文字改變時，更新過濾資料
  useEffect(() => {
    if (!searchText) {
      setFilteredGroupData(groupData);
      return;
    }
    const lower = searchText.toLowerCase();
    const filtered = groupData.filter(
      (item) =>
        (item.group_name && item.group_name.toLowerCase().includes(lower)) ||
        (item.main_identifier && item.main_identifier.toString().toLowerCase().includes(lower))
    );
    setFilteredGroupData(filtered);
  }, [searchText, groupData]);

  const modalColumns = [
    {
      title: <div style={{ textAlign: "center" }}>通知群組</div>,
      dataIndex: "group_name",
      width: 280,
      key: "group_name",
      align: "left",
      onCell: () => ({
        style: {
          paddingLeft: "16px",
        },
      }),
    },
    {
      title: <div style={{ textAlign: "center" }}><Tooltip title={<div>請在信件標題加上`#郵件識別碼`<br />例如:#ue-test</div>}>郵件識別碼</Tooltip></div>,
      dataIndex: "main_identifier",
      key: "main_identifier",
      align: "center",
      width: 120,
      onCell: () => ({
        style: {
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        },
      }),
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          畫線識別碼
        </div>
      ),
      dataIndex: "sub_identifiers",
      key: "sub_identifiers",
      align: "center",
      width: 80,
      render: (_, record) => {
        let subId = [];
        try {
          if (typeof record.sub_identifiers === "string") {
            subId = JSON.parse(record.sub_identifiers);
          } else if (Array.isArray(record.sub_identifiers)) {
            subId = [...record.sub_identifiers];
          }
        } catch (e) {
          console.error("解析 sub_identifiers 失敗:", e);
          subId = [];
        }
        const hasSetting = Boolean(subId && subId.length > 0);
        const text = hasSetting ? subId.join("、") : "未設定畫線";

        return (
          <Tooltip title={text}>
            {renderSettingIcon(hasSetting, () => handleSubIdentifiersSettings(record, subId))}
          </Tooltip>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          關鍵字
        </div>
      ),
      dataIndex: "keywords",
      key: "keywords",
      width: 80,
      align: "center",
      render: (_, record) => {
        let keys = [];
        try {
          if (typeof record.keywords === "string") {
            keys = record.keywords ? JSON.parse(record.keywords) : [];
          } else if (Array.isArray(record.keywords)) {
            keys = record.keywords;
          }
        } catch (e) {
          console.error("解析 keywords 失敗:", e);
          keys = [];
        }
        const hasSetting = keys.length > 0;
        const title = hasSetting ? keys.join("、") : "未設定關鍵字";

        return (
          <Tooltip title={title}>
            {renderSettingIcon(hasSetting, () => handleEdit(record))}
          </Tooltip>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          LINE 設定
        </div>
      ),
      key: "line_setting",
      width: 80,
      align: "center",
      render: (_, record) => {
        let lineIds = [];
        try {
          if (typeof record.line_ids === "string") {
            lineIds = JSON.parse(record.line_ids);
          } else if (Array.isArray(record.line_ids)) {
            lineIds = [...record.line_ids];
          }
        } catch (e) {
          console.error("解析 line_ids 失敗:", e);
          lineIds = [];
        }

        const lineSetting = lineSettings.find((setting) => lineIds.includes(setting.id));
        const hasSetting = Boolean(lineSetting);
        const title = hasSetting ? `LINE: ${lineSetting.setting_name || lineSetting.chat_id}` : "未設定 LINE";

        return (
          <Tooltip title={title}>
            {renderSettingIcon(hasSetting, () => handleLineSettings(record, lineSetting))}
          </Tooltip>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          TG 設定
        </div>
      ),
      key: "tg_setting",
      align: "center",
      width: 80,
      render: (_, record) => {
        let tgIds = [];
        try {
          if (typeof record.tg_ids === "string") {
            tgIds = JSON.parse(record.tg_ids);
          } else if (Array.isArray(record.tg_ids)) {
            tgIds = [...record.tg_ids];
          }
        } catch (e) {
          console.error("解析 tg_ids 失敗:", e);
          tgIds = [];
        }
        const tgSetting = tgSettings.find((setting) => tgIds.includes(setting.id));
        const hasSetting = Boolean(tgSetting);
        const title = hasSetting ? `TG: ${tgSetting.setting_name || tgSetting.chat_id}` : "未設定 TG";
        return (
          <Tooltip title={title}>
            {renderSettingIcon(hasSetting, () => handleTGSettings(record, tgSetting))}
          </Tooltip>
        );
      },
    },
    {
      title: "發報間隔(min)",
      dataIndex: "gap_time",
      align: "center",
      width: 110,
      key: "gap_time",
    },
    {
      title: "群組開關",
      dataIndex: "is_active",
      key: "is_active",
      align: "center",
      width: 80,
      render: (is_active, record) => (
        <Switch
          checked={is_active === 1}
          checkedChildren="ON"
          unCheckedChildren="OFF"
          onChange={(checked) => handleStatusChange(checked, record)}
          size="small"
        />
      ),
    },
    {
      title: "操作",
      key: "action",
      align: "center",
      width: 120,
      render: (filter_id, record) => (
        <Space size="small">
          <Button size="small" variant="outlined" color="green" type="default" onClick={() => handleEdit(record)}>
            編輯
          </Button>
          <Button size="small" variant="outlined" color="red" onClick={() => handleDelete(record)}>
            刪除
          </Button>
        </Space>
      ),
    },
    {
      title: "篩選",
      key: "filter",
      align: "center",
      width: 160,
      render: (_, record) => (
        <Select
          value={record.filter_id}
          style={{ width: "95%" }}
          size="middle"
          onChange={(value) => handleFilterChange(value, record)}
          options={filterOptions.map((option) => ({
            value: option.id,
            label: option.name,
            disabled: option.is_active === 0,
            title: option.description, // 這會顯示為 tooltip
          }))}
        />
      ),
    },
    {
      title: "目的群",
      key: "target_group",
      align: "center",
      width: 160,
      render: (_, record) => (
        <Select
          value={record.tg_option_id}
          style={{ width: "95%" }}
          size="middle"
          onChange={(value) => handleTargetGroupChange(value, record)}
          options={targetGroupOptions.map((option) => ({
            value: option.id,
            label: option.name,
            disabled: option.is_active === 0,
            title: option.description, // 這會顯示為 tooltip
          }))}
        />
      ),
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <Tooltip title="選擇通報範本；不選則 payload 不含警示語那行，且預設顯示主旨">警示語</Tooltip>
        </div>
      ),
      key: "warning_phrase",
      align: "center",
      width: 160,
      render: (_, record) => (
        <Select
          value={record.warning_phrase_id ?? undefined}
          style={{ width: "95%" }}
          size="middle"
          allowClear
          placeholder="不使用"
          onChange={(value) => handleWarningPhraseChange(value, record)}
          options={warningPhraseOptions.map((option) => ({
            value: option.id,
            label: option.name,
            disabled: option.is_active === 0,
            title: `${option.content}${option.include_subject ? "（含主旨）" : "（不含主旨）"}`,
          }))}
        />
      ),
    },
  ];

  const handleDelete = async (record) => {
    Modal.confirm({
      title: "確認刪除",
      content: "確定要刪除此通知群組嗎？此操作只會刪除群組本身，不會刪除相關的 LINE 和 Telegram 設定。",
      okText: "確認",
      cancelText: "取消",
      onOk: async () => {
        try {
          // 只刪除通知群組本身，不刪除 LINE 和 TG 設定
          await NotifyGroupAPI.delete(record.id);

          // 只更新本地的群組資料
          setGroupData((prev) => prev.filter((item) => item.id !== record.id));

          message.success("已成功刪除通知群組");
        } catch (error) {
          message.error("刪除通知群組失敗");
          console.error("刪除通知群組失敗:", error);
        }
      },
    });
  };

  const handleEdit = (group) => {
    console.log("編輯:", group);
    // 實作編輯邏輯
    setSelectedGroup(group);
    setGroupModalVisible(true);
  };

  const handleAddGroup = () => {
    console.log("新增群組");

    setSelectedGroup(null);
    setGroupModalVisible(true);
  };

  const handleGroupSettingSubmit = async (formData) => {
    // 處理儲存邏輯
    setGroupData((prev) => {
      if (selectedGroup) {
        // 修改
        return prev.map((item) => (item.id === selectedGroup.id ? { ...item, ...formData } : item));
      } else {
        // 新增
        return [formData, ...prev];
      }
    });
    setGroupModalVisible(false);
  };

  return (
    <React.Fragment>
      <Modal
        title="訊息群組管理"
        open={open}
        onCancel={handleClose}
        width="calc(100% - 160px)"
        styles={{
          body: {
            height: "100%",
            overflow: "hidden",
          },
        }}
        footer={
          <div style={{ textAlign: "left" }}>
            {/* 添加一個包裝 div 並設置左對齊 */}
            <Button key="add" type="default" onClick={handleAddGroup} style={{ marginRight: 8, background: "var(--content-background)", color: "var(--primary-text)", border: "2px solid var(--primary-border)" }}>
              新增群組
            </Button>
            <Button key="cancel" danger onClick={handleClose}>
              關閉
            </Button>
          </div>
        }
      >
        <div style={{ marginBottom: 12, display: "flex", justifyContent: "flex-start" }}>
          <Input
            className="search-input"
            placeholder="搜尋群組名稱或識別碼"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 360 }}
          />
        </div>
        <Table
          columns={modalColumns}
          dataSource={filteredGroupData}
          loading={loading}
          bordered
          rowKey="id"
          pagination={{
            defaultPageSize: 10,
            showTotal: (total) => `共 ${total} 筆資料`,
            size: "default",
          }}
          scroll={{ x: "max-content", y: 450 }}
          size="small"
        />
      </Modal>
      <PickLineSettingModal
        visible={lineModalVisible}
        onCancel={() => setLineModalVisible(false)}
        onPickup={handleLinePickup}
        selectedGroup={selectedGroup}
        selectedIds={null}
        selectedLineSetting={selectedLineSetting}
        pickupFormat="object"
      />

      <PickTGGroupModal
        visible={tgModalVisible}
        onCancel={() => setTgModalVisible(false)}
        onPickup={handleTGPickup}
        selectedGroup={selectedGroup}
        selectedIds={null}
        selectedTGSetting={selectedTGSetting}
        pickupFormat="object"
      />
      <GroupSettingModal
        visible={groupModalVisible}
        onCancel={() => setGroupModalVisible(false)}
        onSubmit={handleGroupSettingSubmit}
        filterOptions={filterOptions}
        targetGroupOptions={targetGroupOptions}
        selectedGroup={selectedGroup} // 新增這行
      />
      <PickupSubIdentifiersModal
        visible={subIdentifiersModalVisible}
        onCancel={() => setSubIdentifiersModalVisible(false)}
        onPickup={handleSubIdentifiersPickup}
        selectedGroup={selectedGroup}
        selectedSubIdentifiers={selectedSubIdentifiers}
      />
    </React.Fragment>
  );
}